import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import Swal from 'sweetalert2';
import {MatDatepicker} from '@angular/material/datepicker';
import {DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE} from '@angular/material/core';
import { MatInput } from '@angular/material/input';
const moment = require('moment');
const momentTz = require('moment-timezone');
import *  as $ from 'jquery';
import { SheduleService } from 'app/main/pagina/productos/certificar/tipo_2/services/shedule.service';
import {MatSnackBar} from '@angular/material/snack-bar';
import { SurveyStatusV2Service } from "app/main/pagina/tools/survey-status-v2/survey-status-v2.service";
import { zonasUTC } from 'app/main/pagina/zonasUtc';
@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent implements OnInit {
  @ViewChild('recordatorioFechas', { read: undefined }) calReco2: MatDatepicker<Date>;
  @ViewChild('dateStartEnd', { read: undefined }) calDatStaEnd: MatDatepicker<Date>;
  @ViewChild('dateStartEnd2', { read: undefined }) calDatStaEnd2: MatDatepicker<Date>;
  @ViewChild('avisoFechas', { read: undefined }) calAviso2: MatDatepicker<Date>;
  tipoResultados: boolean;
  cambioDato: boolean;
  statusAuditoria: boolean;
  indiceZonaAvisos:string;
  zonasUTCAvisos:string;

  recordatorioBorrado: boolean;
  d=true;
  idRecordatorio:any;
  recordatoriosPermitidos = 1000;
  filtroRecordatorios: any;
  fechaRecoTemp: any;
  fechaStarEndTemp: any;
  recordatorioActualizado: boolean;
    filtroHoraHoy: any;
    horaInstitutoTag: any;
    fechaAvisoTemp: any;
    avisoFechaAvisoActual: any;
    indiceFechaAvisoActual: any;
    filtroAviso: any;
    filtroAviso1: any;
    filtroAviso2: any;
    filtroFechaCertificado: any;
    filtroDate: any;
    esHoy: boolean;
    horaInstituto: any;
    zonasUTC = zonasUTC;
    dateFechaDemoCertificado:any;
    fechaSeleccionadaCertifi:any;
    reasonUpdateCertifi:any="";
    fechaNueva:boolean=false;
    //Variables para modal fecha de inicio y termino
    fechaLanzamiento:any;
    fechaCierre:any;
    tipoFecha:string;
    offsetPipe:any;
    idiomaActual: string;
    fechaActualNave:any;
    fechaRecordatorioAnterior:any;
    languages = [
      {
        id   : 'en',
        title: 'English',
        flag : 'us',
        short: 'en'
      },
      {
        id   : 'es',
        title: 'Español',
        flag : 'es',
        short: 'es'
      },
      {
        id   : 'tr',
        title: 'Turkish',
        flag : 'tr',
        short: 'tr'
      },
      {
        id   : 'zh1',
        title: 'Traditional Chinese',
        flag : 'zh',
        short: 'zh'
      },
      {
        id   : 'zh2',
        title: 'Simplified Chinese',
        flag : 'zh',
        short: 'zh'
      },
    ];
    langSelection:any="";

    pasoCultBrf = 0;
    listaCultBrf: any = [];
    prodCultBrf_temp: any = {};
    prodCultBrf_curr: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public datos: any,
    public dialogRef: MatDialogRef<ModalComponent>,
    private translateSrv: TranslateService,
    private sheduleService: SheduleService,
    private _snackBar: MatSnackBar,
    private svysv2: SurveyStatusV2Service,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
  }


  ngOnInit() {
    this.fechaActualNave= moment();
    console.log('this.fechaActualNave',this.fechaActualNave);

    console.log("datosRecibidos:",this.datos);
    if(this.datos.tipo == 'tipoResultados'){
      this.tipoResultados = this.datos.versionSuccesGo;
    }
    if(this.datos.tipo == 'certifica'){
      this.filtroFechaCertificado = (d: Date | null): boolean => {
        return moment(d || new Date()).format('MM/DD/YYYY') > moment(this.datos.fechaCierre).format('MM/DD/YYYY')
      };
      // this.filtroFechaCertificado = this.datos.fechaCierre;
      this.getDateCertificate();
    }

    if(this.datos.tipo == 'auditoriaManual'){
      this.statusAuditoria = this.datos.info.ManualAudit_Status == 1 ? true : false;
      Swal.close();
    }
    if(this.datos.tipo == 'verRecordatorios'){
    this.filtroRecordatorios = (d: Date | null): boolean => {
      var moment = require('moment');
      const diaInicial = moment(this.datos.recordatorios.fechaLanzamiento);
      const diaFinal = moment(this.datos.recordatorios.fechaLanzamiento).add(21,'days');
      const diaActual = moment(d || new Date());
      return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
    };
    this.horaInstitutoTag = momentTz.tz(this.datos.recordatorios.zonasUTC[this.datos.recordatorios.indiceZona].zona);
    this.horaInstituto = momentTz.tz(this.datos.recordatorios.zonasUTC[this.datos.recordatorios.indiceZona].zona);
    this.indiceZonaAvisos=this.datos.recordatorios.indiceZona;
    // this.zonasUTCAvisos=this.datos.recordatorios.indiceZona].zona;

    }
    if(this.datos.tipo == 'verAvisos'){
    this.filtroRecordatorios = (d: Date | null): boolean => {
      var moment = require('moment');
      const diaInicial = moment(this.datos.recordatorios.d);
      const diaFinal = moment(this.datos.recordatorios.d).add(21,'days');
      const diaActual = moment(d || new Date());
      return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
    };
    this.horaInstitutoTag = momentTz.tz(this.datos.datosAvisos.zonasUTC[this.datos.datosAvisos.indiceZona].zona);
    this.horaInstituto = momentTz.tz(this.datos.datosAvisos.zonasUTC[this.datos.datosAvisos.indiceZona].zona);
    this.indiceZonaAvisos=this.datos.datosAvisos.indiceZona;
    this.filtroAviso1 = (d: Date | null): boolean => {
      let fechaAviso1:any;
      let diaInicial: any;
      if(this.esHoy){
        diaInicial = moment();
      }
      else{
        diaInicial = moment().add(1,'days');
      }

      const diaFinal = moment(this.datos.datosAvisos.fechaLanzamiento).subtract(1,'days');
      const diaActual = moment(d || new Date());
      if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
        console.log("entro lo del mismo año");

        fechaAviso1= diaActual.clone().format('MM/DD/YYYY') >= diaInicial.clone().format('MM/DD/YYYY') && diaActual.isBefore(diaFinal)
      }else{
        console.log("entro lo del otrooooo añooooo");
        fechaAviso1= moment(d || new Date()).format('MM/DD/YYYY') < diaFinal.clone().format('MM/DD/YYYY')

      }

      return fechaAviso1;
    };
    this.filtroAviso2 = (d: Date | null): boolean => {
      // this.fechaInicialGenerica = new Date(moment(this.fechas[1].fecha).year(), moment(this.fechas[1].fecha).month(), 1);
      const diaInicial = moment(this.datos.datosAvisos.fechasAvisos[0].aviso);
      const diaFinal = moment(this.datos.datosAvisos.fechaLanzamiento).subtract(1,'days');
      const diaActual = moment(d || new Date());
      return diaActual.isAfter(diaInicial) && diaActual.isBefore(diaFinal)
    };
    this.calculoHoraMinima();
    }

    if(this.datos.tipo == 'verFechIniCie'){
      // this.filtroFechaCertificado = (d: Date | null): boolean => {
      //   return moment(d || new Date()).format('MM/DD/YYYY') > moment(this.datos.fechaCierre).format('MM/DD/YYYY')
      // };
      this.fechaLanzamiento=this.datos.datosDateStartEnd.datosProducto.fechaCierre.fechaLanzamiento;
      this.fechaCierre=this.datos.datosDateStartEnd.datosProducto.fechaCierre.fechaCierre;
      this.horaInstituto = momentTz.tz(this.datos.datosDateStartEnd.zonasUTC[this.datos.datosDateStartEnd.indiceZona].zona);
      this.horaInstitutoTag = momentTz.tz(this.datos.datosDateStartEnd.zonasUTC[this.datos.datosDateStartEnd.indiceZona].zona);
      this.calculoHoraMinima();
      this.offsetPipe=this.datos.datosDateStartEnd.offsetPipe;
    }

    if(this.datos.tipo == 'cambiaCultureBrief'){
      this.svysv2.getProductos(localStorage.getItem('companyID')).subscribe((respuesta:any) => {
        respuesta.productosCultureAuditV2.forEach(producto => {
          producto.tipo = this.parseaIdTraduccionCA(producto.tipo);
          console.log("PRODCUTO AFTER:",producto);

          if(producto.asociadoId == ''){
            if(producto.tipo == 77){  // ID DE CULTURE BRIEF 2023
              this.listaCultBrf.push(producto);
            }
          } else{
            producto.asociadoId != localStorage.getItem('productoID') ? (producto.tipo == 77 ? this.listaCultBrf.push(producto) : false) : this.prodCultBrf_curr = producto;
          }
        });
        this.listaCultBrf.length == 0 ? this.listaCultBrf.push({texto:'sin_opciones'}) : false;
        this.pasoCultBrf = 1;
      });
    }

  }

  parseaIdTraduccionCA(tipo:number){
    const idsProds = [
      { origen: 4, destino: 30 },
      { origen: 5, destino: 31 },
      { origen: 6, destino: 32 },
      { origen: 7, destino: 33 },
      { origen: 10, destino: 44 },
      { origen: 11, destino: 45 },
      { origen: 12, destino: 46 },
      { origen: 14, destino: 48 },
      { origen: 15, destino: 49 },
      { origen: 22, destino: 64 },
      { origen: 23, destino: 65 },
      { origen: 24, destino: 66 },
      { origen: 25, destino: 67 },
      { origen: 26, destino: 71 },
      { origen: 27, destino: 72 },
      { origen: 28, destino: 73 },
      { origen: 29, destino: 74 },
      { origen: 30, destino: 76 },
      { origen: 31, destino: 77 },
      { origen: 32, destino: 78 },
      { origen: 8, destino: 37 },
      { origen: 16, destino: 50 },
      { origen: 17, destino: 51 },
      { origen: 70, destino: 70 },
      { origen: 18, destino: 55 },
      { origen: 21, destino: 62 }
    ];
    const prodCoincidente = idsProds.find(item => item.origen == tipo);
    return prodCoincidente.destino;
  }

  cambiaTipoResultados(){
    this.cambioDato = true;
  }

  salir_tipoResu(dato?:number){
    this.dialogRef.close(this.cambioDato != undefined ? this.tipoResultados : undefined);
  }


  salir_GuadaraudMan(){
    this.datos.info.ManualAudit_Status = this.statusAuditoria == true ? 1 : 0;
    this.dialogRef.close(this.datos.info);
  }
  salir_SinGuardaraudMan(){
    this.dialogRef.close(undefined);
  }

  fechaRecordatorio(origen:number, event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let moment = require('moment');
    if(origen == 2){
      if(this.datos.recordatorios.fechaLanzamiento){
        let arr=[];
        this.datos.recordatorios.recordatoriosFullInfo.forEach(element => {
          arr.push(moment(element.fechaRecordatorio).format('MM/DD/YYYY'))
        });
console.log('arr',arr);
        if(!arr.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
          console.log("registra el recordatorio");
          //this.registerRecordatorio(date,date);
          this.guardaRecordatorio(fechaElegida);
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
        }
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
      }
    }
  }

  datStarEndSurvey(origen:string, event){
    console.log("evento:",event);
    let fechaElegida = event.value;
    let moment = require('moment');
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    if(origen == 'lanza'){
      this.tipoFecha='lanza';
      if(fechaMoment == moment().format('YYYY-MM-DD')){
        this.setFiltroHoraHoy(true);
      }
      else{
        if(fechaMoment == moment().add(1,'days').format('YYYY-MM-DD')){
          this.setFiltroHoraHoy(false,true);
        }
        else{
          this.setFiltroHoraHoy(false);
        }
      }
      setTimeout(() => {
        console.log("registra la fecha de lanzamiento");
        this.guardaFechaTipoSelec(fechaElegida);

      }, 200);

    }else if(origen == 'cierre'){
      this.tipoFecha='cierre';
      this.guardaFechaTipoSelec(fechaElegida);
    }
  }

  fechaSeleccionadaCertificado(event){
    console.log("evento:",event);
    // let fechaElegida = event.value;
    this.fechaSeleccionadaCertifi=event.value;
    let moment = require('moment');
    let fechaActual=moment(this.dateFechaDemoCertificado).format('YYYY-MM-DD');
    let fechaNueva=moment(this.fechaSeleccionadaCertifi).format('YYYY-MM-DD');
    if (fechaActual==fechaNueva) {
      this.fechaNueva=false;
    }else{
      this.fechaNueva=true;

    }

  }

  guardaRecordatorio(fecha){
    let moment = require('moment');
    this.fechaRecoTemp = moment(fecha).format('YYYY-MM-DD');
    console.log('this.fechaRecoTemp',this.fechaRecoTemp);

    $("#timepickerRecosUpdat").click();

  }

  guardaFechaTipoSelec(fecha){
    let moment = require('moment');
    this.fechaStarEndTemp = moment(fecha).format('YYYY-MM-DD');
    console.log('this.fechaStarEndTemp',this.fechaStarEndTemp);

    $("#timepickerStaEndUpdat").click();

  }

  horaSeleccionadaRecoUpdate(event){
    let moment = require('moment');
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaRecoTemp = this.fechaRecoTemp + " " + hora24;

    let fechaActual = momentTz.tz(this.datos.recordatorios.zonasUTC[this.datos.recordatorios.indiceZona].zona);
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.datos.recordatorios.zonasUTC[this.datos.recordatorios.indiceZona].zona).format()).utcOffset();
    let diferenciaMinutos = momentTz.tz(this.fechaRecoTemp,this.datos.recordatorios.zonasUTC[this.datos.recordatorios.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'seconds'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("fechaActual:",fechaActual.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());
    this.modalGuardado(1);

    if (this.datos.recordatorios.tipoProducto==63) {
      this.datos.recordatorios.recordatoriosFullInfo.forEach((fechaActual,i) => {
        if (fechaActual.fechaRecordatorio==this.fechaRecordatorioAnterior) {
          this.datos.recordatorios.recordatoriosFullInfo.splice(i,1);
        }
      });

      this.datos.recordatorios.recordatoriosFullInfo.push({fechaRecordatorio:fechaTransformadaMasDifUtc.utc(true).toISOString()})

      let data={
        productoId : this.datos.recordatorios.idProducto,
        fechaLanzamiento: this.datos.recordatorios.fechaLanzamiento,
        fechaCierre:this.datos.recordatorios.fechaCierre,
        recordatorios:this.datos.recordatorios.recordatoriosFullInfo,
        recordatoriosN35:this.datos.recordatorios.fechasAvisos,
      };

      console.log('Dato previo a eliminar recordatorio',data);


      this.svysv2.registerDateLanNormv2(localStorage.getItem('companyID'),data).subscribe((respuesta:any) => {
        console.log("guardaReco",respuesta);
        if(respuesta.success){
          this.openSnackBar(this.translateSrv.instant('SHEDULE.REMIDERUPDAOK'),this.translateSrv.instant('ALERTS.OK'));
          Swal.close();
          this.recordatorioActualizado=true;
        }
      }, error => {
      });

    }else{
      let datos={
        nuevaFechaRecordatorio: fechaTransformadaMasDifUtc.utc(true).toISOString(),
        productoId: localStorage.getItem('productoID'),
        idRecordatorio:this.idRecordatorio,
        //encuestaId: localStorage.getItem('encuestaID')  //cuando se trata de focus area alv
      };
      console.log("datosRecoNuevo:",datos);
      this.sheduleService.updateRecordatorios(datos).subscribe((respuesta:any) => {
        console.log("guardaReco",respuesta);
        if(respuesta.message == '200'){
          this.openSnackBar(this.translateSrv.instant('SHEDULE.REMIDERUPDAOK'),this.translateSrv.instant('ALERTS.OK'));
          this.getRecordatorios();
          this.recordatorioActualizado=true;
          Swal.close();
        }else{
          Swal.close();
        }
      }, error => {
      });

    }

  }

  horaSeleccionadaStarEndUpdate(event){
    let moment = require('moment');
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaStarEndTemp = this.fechaStarEndTemp + " " + hora24;

    let fechaActual = momentTz.tz(this.datos.datosDateStartEnd.zonasUTC[this.datos.datosDateStartEnd.indiceZona].zona);
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.datos.datosDateStartEnd.zonasUTC[this.datos.datosDateStartEnd.indiceZona].zona).format()).utcOffset();
    let diferenciaMinutos = momentTz.tz(this.fechaStarEndTemp,this.datos.datosDateStartEnd.zonasUTC[this.datos.datosDateStartEnd.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'seconds'); //se le añade 1 minutos porque siempre se desfasa alv -_-
    let fechaCierre:any;
    if (this.datos.datosDateStartEnd.tipoProducto==43) {
        fechaCierre = moment(fechaActualTransformada).set({hour:23,minute:59,second:0,millisecond:0}).add(diferenciaUtc, 'minutes').add(14, 'days');

    console.log('entraron  los 14 dias de encuesta en pulsechek');
    }else{
      switch (localStorage.getItem('instituto_Empresa')) {
        case '1': case '14': case '18':
        fechaCierre = moment(fechaActualTransformada).set({hour:23,minute:59,second:0,millisecond:0}).add(diferenciaUtc, 'minutes').add(21, 'days');
          break;
        default:
        fechaCierre = moment(fechaActualTransformada).set({hour:23,minute:59,second:0,millisecond:0}).add(diferenciaUtc, 'minutes').add(14, 'days');
          break;
      }
      console.log('entraron los 21 dias de encuesta ');
    }

    console.log("fechaActual:",fechaActual.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());

    if (this.tipoFecha=='lanza') {
      this.modalGuardado(6);
      let data={
        productoId : localStorage.getItem('productoID'),
        fechaLanzamiento: fechaTransformadaMasDifUtc.utc(true).toISOString(),
        accionText:'regisFechaLanza',
        fechaCierre,
        // userAdministrator:this.nameUserAdmin,
        userAdministrator:'',
      };
      console.log("datosRecoNuevo:",data);
      this.svysv2.registerDate2(data).subscribe((respuesta:any) => {
        console.log("guardaUpdateDateLanz",respuesta);
        if(respuesta.message == '200'){
          this.fechaLanzamiento=fechaTransformadaMasDifUtc.utc(true).toISOString();
          // this.getRecordatorios();
          // this.recordatorioActualizado=true;
          this.openSnackBar(this.translateSrv.instant('DAT_STAEND.SUCC_MOD_UPD_DA_STA'),this.translateSrv.instant('ALERTS.OK'));
          Swal.close();
        }else{
          Swal.close();
        }
      }, error => {
      });
    }else if (this.tipoFecha=='cierre') {
      this.modalGuardado(7);
      let datos: any = {
        productoId: localStorage.getItem('productoID'),
        empresaId: localStorage.getItem('companyID'),
        fecha: fechaTransformadaMasDifUtc.utc(true).toISOString(),
      };
      console.log("datosRecoNuevo:",datos);
      this.svysv2.updateFechaCierreUsuarioEmpresa(datos).subscribe((respuesta:any) => {
        console.log("guardaUpdateDateCierre",respuesta);
        if(respuesta.message == '200'){
          this.fechaCierre=fechaTransformadaMasDifUtc.utc(true).toISOString();
          // this.getRecordatorios();
          // this.recordatorioActualizado=true;
          this.openSnackBar(this.translateSrv.instant('DAT_STAEND.SUCC_MOD_UPD_DA_EN'),this.translateSrv.instant('ALERTS.OK'));
          Swal.close();
        }else{
          Swal.close();
        }
      }, error => {
      });
    }


  }

  mensajeSwal(mensaje:string, tipoMsg:number){
    let tipo: any;
    let rspSi = 'MODALES.ACCIONES.aceptar';
    this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
    switch(tipoMsg){
      case 1: tipo = 'success'; break;
      case 2: tipo = 'warning'; break;
      case 3: tipo = 'error'; break;
    }
    Swal.fire({
      title: mensaje,
      icon: tipo,
      confirmButtonText: rspSi,
      confirmButtonColor: '#e40601'
    });
  }

  updRecordatorio(fecha, i){
    console.log('fecha',fecha);
    this.fechaRecordatorioAnterior=fecha.fechaRecordatorio;

  this.idRecordatorio=fecha._id;

    if(this.d){
      console.log('entro aquie 1');
      if(this.datos.recordatorios.recordatoriosFullInfo.length < this.recordatoriosPermitidos){
        console.log('entro aquie 2');

        this.calReco2.open();
      }
      else{
        this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOMAX'), 2);
      }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
    }
  }

  updStarEndDate(tipo){
    console.log('tipo',tipo);

if (tipo=='lanza') {
  this.filtroDate = (d: Date | null): boolean => {
    let fechaMinima: any;
    if(this.esHoy){
      // console.log("entro el primer caso");
      // console.log("primer fecha::::::::",moment().format('MM/DD/YYYY'));
      // console.log("segunda fecha::::::::",moment(d||new Date()).format('MM/DD/YYYY'));

      if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
        // console.log("tomo valor 1",moment(d||new Date()).format('YYYY'));
        fechaMinima = moment(d||new Date()).format('MM/DD/YYYY') >= moment().format('MM/DD/YYYY')

      }else{
      // console.log("tomo valor 2",moment(d||new Date()).format('YYYY'));

        fechaMinima = moment(d||new Date()).format('MM/DD/YYYY')
      }
      // console.log("fecha Minima::::::::",fechaMinima);
    }
    else{
      // console.log("entro el segundo caso");
      if (moment().format('YYYY') == moment(d||new Date()).format('YYYY')) {
        // console.log("tomo valor 1",moment(d||new Date()).format('YYYY'));
      fechaMinima = moment(d || new Date()).format('MM/DD/YYYY') > moment().format('MM/DD/YYYY')
    }else{
      // console.log("tomo valor 2",moment(d||new Date()).format('YYYY'));
      fechaMinima = moment(d || new Date()).format('MM/DD/YYYY')

    }
    }
    return fechaMinima;

  };
  this.calDatStaEnd.open();
}else if (tipo=='cierre') {
  this.filtroDate = (d: Date | null): boolean => {

    let fechaCierre:any;
    let diaInicial: any;
    if(this.esHoy){
      diaInicial = moment();
    }
    else{
      diaInicial = moment().add(1,'days');
    }

    const diaActual = moment(d || new Date());
    // const diaFinal = moment(this.fechaLanza).subtract(1,'days');
    const diaLanzamiento = moment(this.datos.datosDateStartEnd.datosProducto.fechaCierre.fechaLanzamiento);
    const diaCierre = moment(this.datos.datosDateStartEnd.datosProducto.fechaCierre.fechaCierre);
      fechaCierre= moment(d || new Date()).isBefore(diaCierre.clone()) && moment(d || new Date()).isAfter(diaLanzamiento.clone());

    return fechaCierre;
  };

  this.calDatStaEnd2.open();
}

  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }






  borraRecordatorio(fecha:string, indice:number){
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_RECO_1') +': \n\n' + moment(fecha).format('DD-MM-YYYY'),
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {

        //LLAMAR AL SERVICIO QUE LA BORRA EN BACK
        if (this.datos.recordatorios.tipoProducto==63) {
            this.modalGuardado(2);
          const datosRecoFull = this.datos.recordatorios.recordatoriosFullInfo.findIndex(item => item.fechaRecordatorio == fecha);
          if (datosRecoFull!= -1) {
            this.datos.recordatorios.recordatoriosFullInfo.splice(datosRecoFull,1);
          }
          let data={
            productoId : this.datos.recordatorios.idProducto,
            fechaLanzamiento: this.datos.recordatorios.fechaLanzamiento,
            fechaCierre:this.datos.recordatorios.fechaCierre,
            recordatorios:this.datos.recordatorios.recordatoriosFullInfo,
            recordatoriosN35:this.datos.recordatorios.fechasAvisos,
          };

          console.log('Dato previo a eliminar recordatorio',data);


          this.svysv2.registerDateLanNormv2(localStorage.getItem('companyID'),data).subscribe((respuesta:any) => {
            console.log("guardaReco",respuesta);
            if(respuesta.success){
              this.openSnackBar(this.translateSrv.instant('SHEDULE.REMIDERUPDAOK'),this.translateSrv.instant('ALERTS.OK'));
              Swal.close();
              this.recordatorioActualizado=true;
            }
          }, error => {
          });

        }else{
          console.log('No es producto Norma');
          const datosRecoFull = this.datos.recordatorios.recordatoriosFullInfo.find(item => item.fechaRecordatorio == fecha);
          if(datosRecoFull != undefined){
            this.recordatorioBorrado = true;
            let data: any = {
              productoId: localStorage.getItem('productoID'),
              idRecordatorio: datosRecoFull._id
            };
            this.modalGuardado(2);
            this.sheduleService.deleteRecordatorio(data).subscribe((respuesta:any) => {
              console.log("deleteRecordatorio",respuesta);
              // this.data.fechasRecordatorios.splice(indice,1);
              Swal.close();
              this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_RECO_2'),this.translateSrv.instant('ALERTS.OK'));
            }, error => {
              console.log(error);
            });
          }

        }
      }
    });
  }

  borrarAviso(fecha:string, indice:number){
    Swal.fire({
      title: this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_AVI_1') +': \n\n' + moment(fecha).format('DD-MM-YYYY'),
      icon: 'warning',
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: this.translateSrv.instant('MODALES.ACCIONES.aceptar'),
      cancelButtonText: this.translateSrv.instant('MODALES.ACCIONES.cancelar')
    }).then((result) => {
      if (result.value) {
        //LLAMAR AL SERVICIO QUE LA BORRA EN BACK
        let data: any = {
          productoId: localStorage.getItem('productoID'),
          fechaAviso: fecha,
        };
        this.modalGuardado(4);
        this.sheduleService.deleteAvisos(data).subscribe((respuesta:any) => {
          console.log("deleteAvisos",respuesta);
          this.datos.datosAvisos.fechasAvisos.splice(indice,1);
          Swal.close();
          this.openSnackBar(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.BORRA_AVI_2'),this.translateSrv.instant('ALERTS.OK'));
        }, error => {
          console.log(error);
        });
      }
    });
  }
  salir() {
    this.dialogRef.close();
  }

  getRecordatorios(){
    let data: any = {
      productoId: localStorage.getItem('productoID')
    };
    this.sheduleService.getRecordatorios(data).subscribe((respuesta:any) => {
      console.log("respGetReco",respuesta);
      if(respuesta.message == '200'){
        this.datos.recordatorios.recordatoriosFullInfo= respuesta.recordatoriosMostrar;
      }
    }, error => {
      console.log(error);
    });
  }

  modalGuardado(tipo:number){
    let mensaje: string;
    switch (tipo) {
      case 1:
      this.translateSrv.get('ACCIONES.MODALES.UPDA_DAT_RECOR').subscribe((res: string) => { mensaje = res; });
        break;
      case 2:
      this.translateSrv.get('ACCIONES.MODALES.DELE_DAT_RECOR').subscribe((res: string) => { mensaje = res; });
        break;
        case 3: //actualiza fecha aviso
        this.translateSrv.get('SHEDULE2_0.MODALES.ENCUESTA.UPDA_AVISO').subscribe((res: string) => { mensaje = res; });
          break;
        case 4: //elimina fecha aviso
        this.translateSrv.get('SHEDULE2_0.MODALES.ENCUESTA.DELE_AVISO').subscribe((res: string) => { mensaje = res; });
          break;
        case 5: //elimina fecha aviso
        this.translateSrv.get('DAT_CERTI.MOD_UPD_DAT').subscribe((res: string) => { mensaje = res; });
          break;
        case 6: //elimina fecha aviso
        this.translateSrv.get('DAT_STAEND.MOD_UPD_DA_STA').subscribe((res: string) => { mensaje = res; });
          break;
        case 7: //elimina fecha aviso
        this.translateSrv.get('DAT_STAEND.MOD_UPD_DA_EN').subscribe((res: string) => { mensaje = res; });
          break;

      default:
        break;
    }
    Swal.fire({
      title: mensaje,
      allowOutsideClick: false,
      showConfirmButton: false,
      imageUrl: localStorage.getItem('urlGifBroker'),
      imageWidth: 100,
      imageHeight: 60,
    });
  }

  fechaAviso(origen:number, event, fechaAnterior,indice){

    let moment = require('moment');
    let fechaElegida = event.value;
    let fechaMoment = moment(fechaElegida).format('YYYY-MM-DD');
    console.log("fechaNueva:",event);
    console.log("fechaAnterior:",fechaAnterior);
    console.log("fechamoment:",fechaMoment," fechaActual:",moment().format('YYYY-MM-DD'));
    if(fechaMoment == moment().format('YYYY-MM-DD')){
      this.setFiltroHoraHoy(true);
    }
    else{
      if(fechaMoment == moment().add(1,'days').format('YYYY-MM-DD')){
        this.setFiltroHoraHoy(false,true);
      }
      else{
        this.setFiltroHoraHoy(false);
      }
    }

    setTimeout(() => {

      if(origen == 2){
        if(this.d){
          if(!this.datos.datosAvisos.fechasAvisos.includes( moment(fechaElegida).format('MM/DD/YYYY') )){
            console.log("registra el recordatorio");
            this.actualizarAviso(fechaElegida,fechaAnterior);
          }
          else{
            this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOEXIS'), 3);
          }
        }
        else{
          this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
        }
      }
    }, 200);
  }
  updFechaAviso(fecha, i){
    console.log('fecha',fecha);
    if (i==0) {
      console.log('Seleccionando  fecha  indice::',i);
      this.filtroAviso=this.filtroAviso1;
    }else if (i==1) {
      this.filtroAviso=this.filtroAviso2;

    }
this.indiceFechaAvisoActual=i;
this.avisoFechaAvisoActual=fecha.aviso;

    if(this.datos.datosAvisos.fechaLanzamiento){
      console.log('entro aquie 1');
      // if(this.data.fechasRecordatorios.length < this.recordatoriosPermitidos){
        console.log('entro aquie 2');

        this.calAviso2.open();
      // }
      // else{
      //   this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOMAX'), 2);
      // }
    }
    else{
      this.mensajeSwal(this.translateSrv.instant('SHEDULE2_0.MODALES.ENCUESTA.RECOBEFORE'), 3);
    }
  }
  actualizarAviso(fecha,fechaAnterior){
    let moment = require('moment');
    this.fechaAvisoTemp = moment(fecha).format('YYYY-MM-DD');
    console.log('this.fechaRecoTemp',this.fechaAvisoTemp);

    $("#timepickerAvisoUpdat").click();

  }

  horaSeleccionadaAviUpdate (event){
    let moment = require('moment');
    let hora24 = moment(event, ["h:mm A"]).format("HH:mm");
    this.fechaAvisoTemp = this.fechaAvisoTemp + " " + hora24;

    let fechaActual = momentTz.tz(this.datos.datosAvisos.zonasUTC[this.datos.datosAvisos.indiceZona].zona);
    let diferenciaUtc = moment.parseZone(momentTz.tz(this.datos.datosAvisos.zonasUTC[this.datos.datosAvisos.indiceZona].zona).format()).utcOffset();
    let diferenciaMinutos = momentTz.tz(this.fechaAvisoTemp,this.datos.datosAvisos.zonasUTC[this.datos.datosAvisos.indiceZona].zona).diff(fechaActual, 'seconds');
    let fechaActualTransformada = moment(fechaActual).add(diferenciaMinutos, 'seconds');
    diferenciaUtc = diferenciaUtc * -1; //invierte los minutos de diferencia con respecto a utc 0
    let fechaTransformadaMasDifUtc = moment(fechaActualTransformada).add(diferenciaUtc, 'minutes').add(1, 'seconds'); //se le añade 1 minutos porque siempre se desfasa alv -_-

    console.log("fechaActual:",fechaActual.format());
    console.log("diferenciaUtc:",diferenciaUtc);
    console.log("diferenciaMinutos:",diferenciaMinutos);
    console.log("fechaActualTransformada:",fechaActualTransformada.format());
    console.log("fechaTransformadaMasDifUtc:",fechaTransformadaMasDifUtc.utc(true).toISOString());

    let data={
      productoId: localStorage.getItem('productoID'),
      fechaAviso: this.avisoFechaAvisoActual,
      updateAviso: fechaTransformadaMasDifUtc.utc(true).toISOString(),
      //encuestaId: localStorage.getItem('encuestaID')  //cuando se trata de focus area alv
    };
    console.log("datosRecoNuevo:",data);
      // this.modalEspera(1);
      this.modalGuardado(3);
    this.sheduleService.updateAvisoFecha(data).subscribe((respuesta:any) => {
      console.log("guardaReco",respuesta);
      if(respuesta.message == '200'){
        Swal.close();
        this.openSnackBar(this.translateSrv.instant('SHEDULE.AVIUPDAOK'),this.translateSrv.instant('ALERTS.OK'));
        // this.recordatorioActualizado=true;
        this.datos.datosAvisos.fechasAvisos[this.indiceFechaAvisoActual].aviso=fechaTransformadaMasDifUtc.utc(true).toISOString();
      }
    }, error => {
    });

  }

  calculoHoraMinima(){
    let horaMinima = this.horaInstituto.clone().add(4,'hours').format('YYYY-MM-DD');
    let horaActual = moment().format('YYYY-MM-DD');
    // console.log("horaMinima:",horaMinima," horaActual:",horaActual);
    let esHoy = moment(horaActual).isSame(horaMinima);
    this.esHoy = esHoy;
    // console.log("es aun hoy?:",esHoy);
  }

  setFiltroHoraHoy(hoy:boolean,diaSiguiente?:boolean){
    if(hoy){
      console.log("aplicado filtro de hora para hoy");
      // let horaActualMasCuatro = moment().add(4,'hours');
      let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
      console.log("aplicado filtro de hora para hoy");
      if(horaActualMasCuatro.hours() > 12){
        this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
      }
      else{
        this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
      }
    }
    else{
      if(diaSiguiente){
        console.log("aplicado filtro de hora del dia siguiente a hoy");
        if(this.esHoy){
          this.filtroHoraHoy = "00:00 am";
        }
        else{
          let horaActualMasCuatro = this.horaInstituto.clone().add(4,'hours');
          if(horaActualMasCuatro.hours() > 12){
            this.filtroHoraHoy = (horaActualMasCuatro.hours()-12) + ":" + horaActualMasCuatro.minutes() + " pm";
          }
          else{
            this.filtroHoraHoy = horaActualMasCuatro.hours() + ":" + horaActualMasCuatro.minutes() + " am";
          }
        }
      }
      else{
        console.log("aplicado filtro de hora para otro dia");
        this.filtroHoraHoy = "00:00 am";
      }
    }

    console.log("filtroHoraHoy:",this.filtroHoraHoy);
  }


  getDateCertificate(){

    this.svysv2.getCertificateDate(localStorage.getItem('companyID'),localStorage.getItem('productoID')).subscribe((respuesta:any) => {
      console.log("respGetReco",respuesta);
      if(respuesta.message == '200'){
        this.dateFechaDemoCertificado=respuesta.data.outCertificateDate;
      }
    }, error => {
      console.log(error);
    });
  }

  salir_UpdateDateCerti(){
    let data: any = {
      productoId: localStorage.getItem('productoID'),
      newDate:this.fechaSeleccionadaCertifi,
      reason: this.reasonUpdateCertifi,
    };
    let moment = require('moment');
    let fechaActual=moment(this.dateFechaDemoCertificado).format('YYYY-MM-DD');
    let fechaNueva=moment(this.fechaSeleccionadaCertifi).format('YYYY-MM-DD');


    if(this.reasonUpdateCertifi!="") {
      this.modalGuardado(5);
      this.svysv2.updateCertificateDate(localStorage.getItem('companyID'),data).subscribe((respuesta:any) => {
        console.log("updateCertificateDate",respuesta);
        if(respuesta.message == '200'){
          Swal.close();
          // this.datos.recordatorios.recordatoriosFullInfo= respuesta.recordatoriosMostrar;
          this.dialogRef.close();
          this.openSnackBar(this.translateSrv.instant('DAT_CERTI.SUCC_MOD_UPD_DAT'),this.translateSrv.instant('ALERTS.OK'));
        }
      }, error => {
        console.log(error);
      });

    }else{
      let text = 'DAT_CERTI.MOD_ING_REA';
      let rspSi = 'MODALES.ACCIONES.aceptar';
      this.translateSrv.get(text).subscribe((res: string) => { text = res; });
      this.translateSrv.get(rspSi).subscribe((res: string) => { rspSi = res; });
      Swal.fire({
        title: text,
        icon: 'warning',
        confirmButtonText: rspSi,
        confirmButtonColor: '#e40601'
      });

    }
  }

  salirSinHora(event){
    console.log("salirSinHora:",event);
  }

  salir_IdiomaCertificado(){
    // this.dialogRef.close();
    this.dialogRef.close(this.langSelection);
  }
  selIdiomaCertificado(lang:any){
    this.langSelection=lang.id;
    console.log('this.langSelection',this.langSelection);
  }

  async asociarCultureBrief(){
    let mensajeTexto3 = this.translateSrv.instant('ACCIONES.SUBACCIONES.cambiaCultureBrief.MESSAGE3');
    let mensajeTexto4 = this.translateSrv.instant('ACCIONES.SUBACCIONES.cambiaCultureBrief.MESSAGE4');
    let mensajeTexto5 = this.translateSrv.instant('ACCIONES.SUBACCIONES.cambiaCultureBrief.MESSAGE5');
    let confirmarEmpresa = this.translateSrv.instant('ACCIONES.SUBACCIONES.cambiaCultureBrief.VALIDAR');
    let salir = this.translateSrv.instant('ACCIONES.SUBACCIONES.cambiaCultureBrief.SALIR');
    let errorNombreEmpresa = this.translateSrv.instant('ACCIONES.SUBACCIONES.cambiaCultureBrief.ERRORNOMBREEMPRESA');
    let cerrar = this.translateSrv.instant('ACCIONES.SUBACCIONES.cambiaCultureBrief.CERRAR');

    let codigo = Math.random().toString(36).substring(7);

    Swal.fire({
      title: mensajeTexto3+'<font color="red">'+ codigo+'</font>'+mensajeTexto4,
      icon: 'info',
      input:'text',
      showCancelButton: true,
      reverseButtons: true,


      cancelButtonText: salir,
      confirmButtonText: confirmarEmpresa
    })
    .then( async (borrar) => {
      console.log(borrar);
      if (borrar.value == codigo) {

        const datos = {
          productoId: localStorage.getItem('productoID'),
          cultureId: this.prodCultBrf_temp.idCulture
        }
        const resultado = await this.svysv2.asociarCultureBrief(datos).toPromise().then((res:any) => {return res});
        console.log("RESULTADO ASOCIAR:",resultado);
        if(resultado.success == true){
          Swal.fire({
            title: mensajeTexto5,
            icon: 'success',
            showCancelButton: false,
            reverseButtons: true,
            confirmButtonText: confirmarEmpresa
          });
          this.prodCultBrf_curr = JSON.parse(JSON.stringify(this.prodCultBrf_temp));
        }


      }
      else{
        if(!borrar.dismiss){
          Swal.fire({
            icon: 'error',
            title: errorNombreEmpresa,
            showConfirmButton: true,

            confirmButtonText: cerrar
          })
        }

      }
    });
  }

}
